module.exports = __webpack_public_path__ + "static/media/latam-internacional.c244930c.png";